import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { useRequireApiDocsManager, useSheet } from '../api';
import { SheetPages } from '../SheetPages';

export function SheetViewPage() {
  useRequireApiDocsManager();
  const { id } = useParams<{ id: string }>();
  const sheet = useSheet(id);

  return (
    <ScrollPage>
      <PageHeader
        title={sheet.data?.sheetName ?? 'Sheet'}
        actions={
          <Button variant="outline" asChild>
            <Link to="/superadmin-api-docs/sheet-content">
              <ArrowLeft className="h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />
      {sheet.isLoading && (
        <div className="flex h-64 items-center justify-center gap-2 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" /> Loading…
        </div>
      )}
      {sheet.isError && <p className="text-sm text-destructive">Sheet not found or you do not have access.</p>}
      {sheet.data && <SheetPages sheet={sheet.data} />}
    </ScrollPage>
  );
}
